import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { toHttpParams } from '../utils/globals';
import { DateRange, PagedList, PaymentApprovalModel } from '../interface';
import { PaymentApprovalStatus } from '../enum';

@Injectable({
  providedIn: 'root'
})
export class HxPaymentApprovalService {

  constructor(private http: HttpClient) {
  }

  getPaymentApprovalList(params?: {
    page?: number,
    limit?: number,
    supplierId?: number,
    query?: string,
    date?: DateRange,
    status?: PaymentApprovalStatus,
    includeDisabled?: boolean,
    storeId?: number,
    paid?: boolean;
  }): Promise<PagedList<PaymentApprovalModel>> {
    return firstValueFrom(this.http.get<PagedList<PaymentApprovalModel>>(`/api/vn/payment-approvals`, {params: toHttpParams(params, true)}));
  }

  getPaymentApprovalById(paymentApprovalId: number): Promise<PaymentApprovalModel> {
    return firstValueFrom(this.http.get<PaymentApprovalModel>(`/api/vn/payment-approvals/${paymentApprovalId}`));
  }

  savePaymentApproval(request: PaymentApprovalRequest): Promise<{id: number}> {
    return firstValueFrom(this.http.post<{id: number}>(`/api/vn/payment-approvals`, request));
  }

  removePaymentApproval(paymentApprovalId: number): Promise<any> {
    return firstValueFrom(this.http.delete<void>(`/api/vn/payment-approvals/${paymentApprovalId}`));
  }

  cancelPaymentApproval(paymentApprovalId: number, reason: string): Promise<any> {
    return firstValueFrom(this.http.post<void>(`/api/vn/payment-approvals/${paymentApprovalId}/cancel`, {reason: reason}));
  }

  paidPaymentApproval(body: {ids: number[]}): Promise<any> {
    return firstValueFrom(this.http.post<void>(`/api/vn/payment-approvals/paid`, body));
  }

  removePaymentApprovalInvoice(paymentApprovalId: number, invoicePaymentId: number): Promise<any> {
    return firstValueFrom(this.http.delete<void>(`/api/vn/payment-approvals/${paymentApprovalId}/invoice-payment/${invoicePaymentId}/cancel`));
  }
}

export interface PaymentApprovalRequest {
  id: number;
  storeId: number;
  supplierId: number;
  bankAccountId: number;
  date: string;
  total: number;
  note: string;
  paymentDestinationCode: string;
  invoicePayments: InvoicePaymentRequest[];
}

export interface InvoicePaymentRequest {
  invoiceId: number;
  value: number;
}
